import { useParams, useSearchParams } from "react-router";
import React, {  useEffect, useRef, useState } from "react";
import EditorMeunBar from "./left/Menubar";
import MockupEditor,{ Action, ActionName, EventCallbackParams, EventCallbackParamsType, FineTuningObject, ImagesObject, ItemBase64, MockupObject } from "./MockupEditor";
import { useHttpUtil } from "context/HttpContext";
import FineTuning from "./right/FineTuning";
import Toolskit from "./right/Toolskit";
import SmartColor from "./right/SmartColor";
import MouseMode from "./top/MouseMode";
import DetailContextProvider from "./DetailContext";
import SaveArea from "./top/SaveArea";
import EditorFunctionBtns from "./top/EditorFunctionBtns";
import UploadedTips from "./guide/UploadedTips";
import AreaSelect from "./right/AreaSelect";
import MockupsContextProvider from "../mockups/MockupsContext";
import { useGuidesContext } from "./guide/Guides";


export default function ProjectEditorDetail(props: { isMockupsSrc ?: boolean}){
    const { isMockupsSrc = false} = props ;
    const params = useParams() ;

    const httpUtil = useHttpUtil();

    const guidesContext = useGuidesContext();

    const [projectId] = useState<string>(params.id || '')

    const [project, setProject] = useState<ProjectInfo>(() => {
        return {
            name : ''
        }
    });

    const [editorAction, setEditAction] = useState<Action>();

    // 编辑器的手势模式0-2
    const [modeType, setModeType] = useState<number>(0);

    // 编辑器选择图片时的工具栏模式1-5
    const [imageEditType, setImageEditType] = useState<number>(0);

    // 编辑器选择底图时的工具栏模式1-2
    const [modelEditType, setModelEditType] = useState<number>(0);

    // 选中图像数据, type- 2：向量图 1: 底图
    const [checkedElementData, setCheckedElementData] = useState<MockupObject>();

    // 是否多选
    const [ isSelectedMore , setIsSelectedMore] = useState<boolean>(false);

    const [ editorCallbackData, setEditorCallbackData ] = useState<EventCallbackParams>();

    // useEffect(() => {
    //     setProjectId(params.id as string)
    // }, [params.id])

    useEffect(() => {
        if(projectId){
            loadProject();
        }
    },[projectId]);

    useEffect(() => {
        if(guidesContext?.isGuideModal){
            if(guidesContext?.model === 'color'){
                setImageEditType(() => {
                    return guidesContext.currentGuideIndex === 2 ? 4 : 0; 
                })
            }
        }else{
            setImageEditType((imageEditType: number) => {
                return imageEditType === 4 ? 0 : imageEditType; 
            })
        }
    }, [guidesContext?.isGuideModal, guidesContext?.model, guidesContext?.currentGuideIndex])


    const loadProject = async function(){
        if(!isMockupsSrc){
            const data = await httpUtil.post('/biz/project/detail', {
                projectId
            })
            if(!data.errCode){
                setProject(data.data);
                // loadingContext?.setIsLoadingLayout(false);
            }else{
                location.replace('/')
            }
        }
    }

    // 触发编辑器指令
    const triggerEditorAction = (action: Action) => setEditAction(action)


    // 点击素材库的图片，需加载到编辑器中
    const choiceMaterialImage = (urls: string | string[]) => {
        if(!urls) return ;

        let url : string ;
        if(Array.isArray(urls)){
            if(urls.length > 1){
                const maxCol = urls.length > 9 ? 4 : 3;
                const imagesObject : ImagesObject = {
                    images: urls,
                    maxCol: maxCol,
                    space: 50,
                    width: 270,
                    height: 270
                }
                setTimeout(() => {
                    triggerEditorAction({
                        name: ActionName.ADD_IMAGES,
                        params: imagesObject
                    })
                },30);
                return ;
            }
            url = urls[0];
        }else{
            url = urls ;
        }
        if(/shopify\.com/ig.test(url)){
            url = url.split('\?')[0];
        }

        setTimeout(() => {
            triggerEditorAction({
                name: ActionName.LOADING_IMAGE,
                params: url as string
            })
        },30);
    }

    // 编辑器的相关回调监听
    const onEditorDataListener = async (data: EventCallbackParams) => {
        setEditorCallbackData({...data});
        switch(data.type){
            case EventCallbackParamsType.ITEM_BASE64_CHANGE:
                // const itemBase64 = data.data as ItemBase64 ;
                // console.info(itemBase64);
                if(!project.projectId) return ; // mockups模式先不做保存??
                if(data?.data && project.projectId){
                    await httpUtil.uploadBytes({
                        projectId: project.projectId,
                        id: data.data.md5 + data.data.type,
                        bytes: data?.data.base64
                    })
                }
                break;
            case EventCallbackParamsType.MOUSE_CHANGE_CALLBACK:
                setModeType(+data.data)
                break;
            case EventCallbackParamsType.OBJECT_SELECT: // 对象选中
                // 非转换类型时 | 或转换类型时只有当选中状态时，才需更新选中数据
                if(data.callbackType !== 16 || checkedElementData?.uuid === data.data.uuid){
                    setCheckedElementData({...(data.data as MockupObject)})
                } 
                setIsSelectedMore(false);
                break;
            case EventCallbackParamsType.OBJECT_CANCEL_SELECT: // 取消选中
                setCheckedElementData(undefined)
                setIsSelectedMore(data.data as boolean)
                break;
        }
    }

    const dragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy"
    }

    const dragEnd = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const url = event.dataTransfer.getData('imageUrl') ;
        url && choiceMaterialImage(url);
    }

    return (
        <DetailContextProvider detail={{
            project, setProject,
            imageEditType, setImageEditType, 
            modelEditType, setModelEditType,
            isSelectedMore,
            checkedElementData, setCheckedElementData, 
            editorCallbackData, 
            editorAction, triggerEditorAction
        }}>
            <MockupsContextProvider isMockupsSrc={isMockupsSrc}>
                {/* <OpeartionGuide> */}
                    <div className="h-full w-full flex flex-col ">
                        <header className="flex items-center h-[60px] xl:px-[30px] px-[10px] border-b-[#EBEBEB] border-b-[1px]">
                            <MouseMode setProject={setProject} modeType={modeType} />
                            <div className="grow flex justify-center">
                                <EditorFunctionBtns/>
                            </div>

                            {/* 保存/下载 */}
                            <SaveArea />
                        </header>
                        <div className="relative grow flex w-full h-full">
                            <EditorMeunBar onImageClick={choiceMaterialImage}/>
                            <div className="relative flex grow w-full bg-[#EFF3F5]"
                                onDragOver={(event) => dragOver(event)}
                                onDrop={(event) => dragEnd(event)}
                                style={{
                                    cursor: modeType == 0 ? 'default' : 'pointer'
                                }}>
                                <MockupEditor action={editorAction} project={project} onDataListener={onEditorDataListener}/>
                            </div>
                            { imageEditType == 4  && <SmartColor /> } { /* 智能换色 */ }
                            { /* 智能选区 */ }
                            { modelEditType == 1 && <AreaSelect /> } 
                            { <FineTuning/> }{ /* 底图上的向量图属性设置 */ }
                            <Toolskit /> { /* 右下角工具条  */ }                
                        </div>
                    </div>
                    <UploadedTips />
                {/* </OpeartionGuide> */}
            </MockupsContextProvider>
        </DetailContextProvider>
    )
}

export type ProjectInfo = {
    projectId?: string,
    name : string,
    content?: string,
    baseUrl?: string,
    urls?: any
}

export type MockupDetail = {
    url ?: string,
    isEditorLoaded ?: boolean,
    isImageLoaded ?: boolean,
    isMockuped ?: boolean
}